import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { closePopup } from '../../actions/uiActions';
import CloseIcon from '@mui/icons-material/Close';
import FolderOpenIcon from '@mui/icons-material/FolderOpen'
import { DatabaseIcon } from '../../images/js/databaseIcon';
import { sendEditPresentationInfo } from '../../actions/presentationActions';

class EditPresentationInfo extends React.Component {
    state = {
        template: false,
        customerID: null,
        teamIDs: [],
        tagIDs: [],
        folderID: null,
        databases: {}
    }

    componentDidMount() {
        let pres = this.props.presentationList.find(x => x.id === parseInt(this.props.presID));
        let teamList = (pres.presentationTeams !== null) ? pres.presentationTeams.map(x => x.team.id) : [];
        let tagList = (pres.presentationTags !== null) ? pres.presentationTags.map(x => x.tag.id) : [];
        let databaseConnectionList = {};

        if (pres.connections) {
            pres.connections.forEach(connection => {
                databaseConnectionList[connection.id] = null;
            });
        }

        this.setState({ teamIDs: teamList, customerID: pres.customerID, folderID: pres.folderID, template: pres.isTemplate, tagIDs: tagList, databases: databaseConnectionList });

    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    handleSubmit = (event) => {
        if (event.preventDefault !== undefined) { event.preventDefault(); }
        console.log('------>>>********handleSubmit*****state****', this.state);
        this.props.sendEditPresentationInfo(this.props.connInfos[0].id, -1, this.state.folderID, this.props.presID, this.state.customerID, this.state.template, this.state.teamIDs, this.state.tagIDs, this.state.databases)
    }

    handleMultiDatabaseEntry = (event, index) => {
        event.preventDefault();
        let databases = this.state.databases;
        databases[index] = (event.target.value === "") ? null : event.target.value;
        this.setState({ databases: databases });
    }

    handleFolder = (event) => {
        event.preventDefault()
        this.setState({ folderID: event.target.value })
    }

    handleTemplateChange = (event) => {
        let newVal = !this.state.template;
        
        let pres = this.props.presentationList.find(x => x.id === parseInt(this.props.presID));
        pres.isTemplate = newVal;
        this.setState({ template: newVal });
    }

    handleCustomer = (event) => {
        event.preventDefault()
        this.setState({ customerID: parseInt(event.target.value) })
    }

    handleTeamCheckBoxes = (event) => {
        // console.log(event.target.value)
        let ind = this.state.teamIDs.findIndex(x => x === parseInt(event.target.value))
        let arr = this.state.teamIDs
        if (ind !== -1) {
            arr.splice(ind, 1)
        } else {
            arr.push(parseInt(event.target.value))
        }
        this.setState({ teamIDs: arr })
    }

    handleTagCheckBoxes = (event) => {
        let ind = this.state.tagIDs.findIndex(x => x === parseInt(event.target.value))
        let arr = this.state.tagIDs
        if (ind !== -1) {
            arr.splice(ind, 1)
        } else {
            arr.push(parseInt(event.target.value))
        }
        this.setState({ tagIDs: arr })
    }

    populateTeamCheckBoxes = () => {
        if (this.state.customer !== null) {
            let teams = this.props.teamList.filter(x => x.customer.id === this.state.customerID)

            if (this.props.role === "Builder" || this.props.role === "Viewer") {
                let filteredTeams = []

                if (this.props.currentUser !== null) {
                    for (let allTeamIndex = 0; allTeamIndex< teams.length; allTeamIndex++) {
                        for (let userTeamIndex = 0; userTeamIndex < this.props.currentUser.applicationUserTeams.length; userTeamIndex++) {
                            if (teams[allTeamIndex]["id"] === this.props.currentUser.applicationUserTeams[userTeamIndex]["teamID"]) {
                                filteredTeams.push(teams[allTeamIndex])
                            }
                        }
                    }
                }

                teams = filteredTeams
            }

            return (<>
                {teams.map(x => (
                    <li key={`team=${x.id}`}>
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    defaultChecked={(this.state.teamIDs.find(y => y === x.id) !== undefined) ? true : false}
                                    value={x.id}
                                    onChange={this.handleTeamCheckBoxes}
                                    name={x.name}
                                />
                            )}
                            label={x.name}
                        />
                    </li>
                ))}
            </>
            )
        }
        return (<div style={{ align: "center", height: "40px" }} />)
    }

    populateTagCheckBoxes = () => {
        
        if (this.state.customer !== null) {
            let tags = this.props.tagsList
            return (<>
                {tags.map(x => {
                const defaultChecked= Boolean(this.state.tagIDs.find(y => y === x.id));
                return (
                    <li key={x.id}>
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    defaultChecked={defaultChecked}
                                    value={x.id}
                                    onClick={this.handleTagCheckBoxes}
                                    name={x.displayName}
                                />
                            )}
                            label={x.displayName}
                        />
                    </li>
                )}
                )}
            </>)
        }
        return (<div style={{ align: "center", height: "40px" }} />)
    }

    handleCustomerDropDown = (pres) => {

        if (this.props.role === "IEAdmin" && this.props.customerID === 1) {
            return (<div><h4>Edit Customer</h4>
                <Select
                className="myInput"
                value={this.state.customerID}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                defaultValue={pres.customerID}
                onChange={this.handleCustomer}
                id="customers_list"
            >

                {this.props.customerList.map((x) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
            </Select></div>)
        } else {
            return <h5 style={{ marginBottom: "0px" }}>{this.props.customerName}</h5>
        }

    }

    populateFolders = () => {
        if (this.props.folderList) {
            return (
                <Select
                    value={this.state.folderID == null ? "" : this.state.folderID }
                    className="myInput"
                    onChange={this.handleFolder}
                    displayEmpty
                    required
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value="">No Folder</MenuItem>

                    { this.props.folderList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.folderName}</MenuItem>)}

                </Select>
            )
        } else {
            return (<div />)
        }
    }

    populateAllDatabases = (pres) => {
        if (pres.connections) {
            return pres.connections.map((conn, index) => {
                return <div className="myInputOut" key={`db-connection-${conn.id}`} style={{ "height":"70px" }}>
                    <div className="checkHead" style={{ "clear":"both" }}>{conn.tagName}:</div>
                    <DatabaseIcon style={{ display: "block", float: "left", paddingTop: "10px" }} />
                    <div style={{ float: "right", width: "90%" }}>
                        <Select
                            className="myInput"
                            onChange={(e) => this.handleMultiDatabaseEntry(e, conn.id)}
                            defaultValue=''
                            displayEmpty
                            required
                            inputProps={{ 'aria-label': 'Without label' }}>
                            <MenuItem value="">Change Database</MenuItem>
                            {this.props.dbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                        </Select>
                    </div>
                </div>
            });
        }
    };

    render() {
        const pres = this.props.presentationList.find(x => x.id === parseInt(this.props.presID));

        return (<Dialog
            open={true}
            onClose={this.handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <CloseIcon onClick={this.handleClick} className="closePoup" />
            <DialogTitle id="alert-dialog-title" className="changepassdialog">
                {'Edit Presentation Info'}
                {' '}
            </DialogTitle>
           
            <DialogContent id="alert-dialog-description">
                
                <div className="myInputOut">
                    <FolderOpenIcon style={{ display: "block", float: "left", paddingTop: "10px" }} /><div style={{ float: "right", width: "90%" }}> {this.populateFolders()} </div>
                </div>
                <br/><div>&nbsp;</div>
                {this.populateAllDatabases(pres)}
                    <div className="passwordResetbox">
                        {this.handleCustomerDropDown(pres)}

                        <div>
                            <label>Template Presentation: &nbsp; </label>
                            <FormControlLabel
                                control={(
                                    <Checkbox
                                        checked={pres.isTemplate}
                                        onChange={this.handleTemplateChange}
                                        name="Templete"
                                    />
                                )}
                            />
                        </div>
                        <div className="checkOut">
                            <label className="checkHead">Teams:</label>
                            <ul>
                                {this.populateTeamCheckBoxes(pres.customerID)}
                            </ul>
                        </div>
                        <div className="checkOut">
                            <label className="checkHead">Tags:</label>
                            <ul>
                                {this.populateTagCheckBoxes()}
                            </ul>
                        </div>
                    </div>
                    <div>
                        <button className="btn" onClick={this.handleSubmit}>
                            Submit
                    </button>
                       
                    </div>
                </DialogContent>
  
        </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        connInfos: state.presentations.present.connInfos,
        customerName: state.users.customerName,
        customerList: state.users.customerList,
        customerID: state.users.customerID,
        presentationList: state.presentations.present.presentationList,
        teamList: state.users.teamList,
        tagsList: state.presentations.present.tagsList,
        role: state.users.role,
        dbList: state.users.custDBList,
        folderList: state.users.custFolderList,
        currentUser: state.users.currentUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, sendEditPresentationInfo }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditPresentationInfo)